// extracted by mini-css-extract-plugin
export default {"item":"AboutItem_item__ykiES","head_wrap":"AboutItem_head_wrap__6L5xq","active":"AboutItem_active__QQDKd","content":"AboutItem_content__O+mAX"};